import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { AppState } from 'app/app.reducers';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { Observable } from 'rxjs';
import { getAdminWorkspacesForPropertyReassign } from '../../admin-store/admin.selectors';
import { SelectionChangedEvent } from 'devextreme/ui/autocomplete';
import { DxAutocompleteComponent } from 'devextreme-angular';
import { SubSink } from 'subsink';

@Component({
  selector: 'sp-admin-reassign-property-modal',
  templateUrl: './admin-reassign-property-modal.component.html',
  styleUrls: ['./admin-reassign-property-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AdminReassignPropertyModalComponent implements AfterViewInit, OnInit, OnDestroy {

  @ViewChild(ModalDirective, { static: true }) public bsModal: ModalDirective;
  @ViewChild('dxPortfolioSearch', { static: false }) dxPortfolioSearch: DxAutocompleteComponent;

  @Output() onConfirm = new EventEmitter<{ propertyId: string, destinationWorkspaceId: string, includeUsers: boolean }>();

  allWorkspaces$: Observable<any[]>; // {name, workspaceId} See getAdminWorkspacesForPropertyReassign selector
  allWorkspaces: any[] = [];
  filteredWorkspaces: any[] = [];

  propertyId: string;
  propertyName: string;
  fromWorkspaceName: string;
  fromWorkspaceId: string;

  toWorkspaceId: string;
  includeUsers: boolean = false;

  private subs = new SubSink();

  constructor(
    private ref: ChangeDetectorRef,
    private store: Store<AppState>
  ) {
    this.allWorkspaces$ = this.store.pipe(select(getAdminWorkspacesForPropertyReassign));
  }

  ngOnInit(): void {
    this.subs.sink = this.allWorkspaces$.subscribe(workspaces => {
      if (workspaces) {
        this.allWorkspaces = workspaces;
      }
    });
  }

  ngAfterViewInit() {
    this.bsModal.config.keyboard = false;
    this.bsModal.config.ignoreBackdropClick = true;
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  show(propertyId: string, propertyName: string, fromWorkspaceId: string): void {

    this.propertyId = propertyId;
    this.propertyName = propertyName;
    this.fromWorkspaceId = fromWorkspaceId;

    this.fromWorkspaceName = this.allWorkspaces.find(a => a.workspaceId === fromWorkspaceId).name;
    this.filteredWorkspaces = this.allWorkspaces.filter(a => a.isActive && a.workspaceId !== fromWorkspaceId);

    this.ref.detectChanges();

    this.bsModal.show();
  }

  closeModal(): void {
    this.dxPortfolioSearch.instance.reset();
    this.bsModal.hide();
    this.toWorkspaceId = null;
  }

  onWorkspaceSelected(e: SelectionChangedEvent) {
    if (e.selectedItem) {
      this.toWorkspaceId = e.selectedItem.workspaceId;
    } else {
      this.toWorkspaceId = null;
    }
  }

  toggleIncludeUsers() {
    this.includeUsers = !this.includeUsers;
  }

  reassignProperty() {
    if (this.toWorkspaceId && this.propertyId) {
      this.onConfirm.emit({ propertyId: this.propertyId, destinationWorkspaceId: this.toWorkspaceId, includeUsers: this.includeUsers });
    }
    this.closeModal();
  }
}
